import { render, staticRenderFns } from "./addWx.vue?vue&type=template&id=af74cf02&scoped=true&"
import script from "./addWx.vue?vue&type=script&lang=js&"
export * from "./addWx.vue?vue&type=script&lang=js&"
import style0 from "./addWx.vue?vue&type=style&index=0&id=af74cf02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af74cf02",
  null
  
)

export default component.exports